import { render } from "./takat-right-collection.vue?vue&type=template&id=67969142&scoped=true"
import script from "./takat-right-collection.vue?vue&type=script&lang=js"
export * from "./takat-right-collection.vue?vue&type=script&lang=js"

import "./takat-right-collection.vue?vue&type=style&index=0&id=67969142&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67969142"]])

export default __exports__